(() => {
  const root = document.querySelector('[data-article-content]');
  if (!root) return;

  const toc = document.querySelector('[data-toc]');
  const list = toc ? toc.querySelector('[data-toc-list]') : null;
  if (!toc || !list) return;

  const getOffset = () => (window.innerWidth < 750 ? 120 : 165);

  const slugify = (text) =>
    (text || '')
      .toLowerCase()
      .trim()
      .replace(/&amp;|&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const uniqueId = (base) => {
    let id = base || 'section';
    let i = 2;
    while (document.getElementById(id)) {
      id = `${base}-${i++}`;
    }
    return id;
  };

  const paragraphs = root.querySelectorAll('p');
  const anchorP = paragraphs[1] || paragraphs[0];
  if (!anchorP) return;

  const headings = Array.from(root.querySelectorAll('h2, h3'))
    .filter((h) => !h.closest('[data-toc]'))
    .filter((h) => (h.textContent || '').trim().length > 0);

  const h2Count = headings.filter((h) => h.tagName === 'H2').length;
  if (h2Count < 2) {
    toc.remove();
    return;
  }

  toc.hidden = false;
  anchorP.insertAdjacentElement('afterend', toc);

  headings.forEach((heading, index) => {
    const tag = heading.tagName.toLowerCase();
    const text = (heading.textContent || '').trim();
    if (!text) return;

    if (!heading.id) {
      const base = slugify(text) || `sec-${index + 1}`;
      heading.id = uniqueId(base);
    }

    heading.style.scrollMarginTop = `${getOffset()}px`;

    const li = document.createElement('li');
    if (tag === 'h3') li.className = 'hz-toc__item--h3';

    const a = document.createElement('a');
    a.href = `#${heading.id}`;
    a.textContent = text;
    a.className = tag === 'h3' ? 'hz-toc__link--h3' : 'hz-toc__link--h2';

    li.appendChild(a);
    list.appendChild(li);
  });

  toc.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const id = link.getAttribute('href').slice(1);
    const target = document.getElementById(id);
    if (!target) return;

    e.preventDefault();

    const offset = getOffset();
    const y = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: y,
      behavior: 'smooth',
    });

    history.replaceState(null, '', `#${id}`);
  });

  if (window.location.hash) {
    const id = window.location.hash.slice(1);
    const target = document.getElementById(id);

    if (target) {
      setTimeout(() => {
        const offset = getOffset();
        const y = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: 'auto' });
      }, 50);
    }
  }
})();

(() => {
  const root = document.querySelector('[data-article-content]');
  if (!root) return;

  const headings = Array.from(root.querySelectorAll('h2, h3'));
  const faqHeading = headings.find((h) => /faq/i.test((h.textContent || '').trim()));
  if (!faqHeading) return;

  const entities = [];
  let node = faqHeading.nextElementSibling;

  while (node) {
    if (node.tagName === 'H2') break;

    if (node.tagName === 'H3') {
      const question = (node.textContent || '').trim();
      const answerParts = [];
      let next = node.nextElementSibling;

      while (next && next.tagName !== 'H3' && next.tagName !== 'H2') {
        const text = (next.textContent || '').trim();
        if (text) answerParts.push(text);
        next = next.nextElementSibling;
      }

      const answer = answerParts.join(' ').trim();

      if (question && answer) {
        entities.push({
          '@type': 'Question',
          name: question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: answer,
          },
        });
      }
    }

    node = node.nextElementSibling;
  }

  if (!entities.length) return;

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: entities,
  });

  document.body.appendChild(script);
})();